import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';

import { Agent } from './agent.model';

/**
 * `GET agents/agents`: the agents the signed-in account may use, exactly as the backend decides
 * (ownership, sharing, department access, module permission). One client for every app, so the
 * dashboard's `AgentService.getAll` and the messenger's agent list cannot drift apart.
 */
@Injectable({ providedIn: 'root' })
export class AgentsListApi {
    private readonly _http = inject(HttpClient);

    getAll(name?: string): Observable<Agent[]> {
        let params = new HttpParams();
        if (name) {
            params = params.append('name', name);
        }
        return this._http
            .get<{ data: { agents: Agent[] } }>(environment.apiLink + 'agents/agents', { params })
            .pipe(map(res => res.data.agents));
    }
}
